import React, { memo } from 'react';
import { Shape } from '../../types/Shape';
import { getConnectionPoints } from '../../utils/connectionUtils';

interface ConnectionPointsProps {
  shape: Shape;
  stagePos: { x: number; y: number };
  stageScale: number;
  show: boolean;
  snappedPoint?: { x: number; y: number } | null;
}

const ConnectionPoints: React.FC<ConnectionPointsProps> = ({
  shape,
  stagePos,
  stageScale,
  show,
  snappedPoint,
}) => {
  if (!show) return null;

  const connectionPoints = getConnectionPoints(shape);
  const pointSize = 14; // 터치 환경을 고려하여 크기 증가

  return (
    <>
      {Object.entries(connectionPoints).map(([position, point]) => {
        const screenX = point.x * stageScale + stagePos.x;
        const screenY = point.y * stageScale + stagePos.y;

        // 스냅된 포인트인지 확인
        const isSnapped = snappedPoint &&
          Math.abs(snappedPoint.x - point.x) < 1 &&
          Math.abs(snappedPoint.y - point.y) < 1;

        return (
          <div
            key={`${shape.id}-${position}`}
            style={{
              position: 'absolute',
              left: screenX - pointSize / 2,
              top: screenY - pointSize / 2,
              width: pointSize,
              height: pointSize,
              backgroundColor: isSnapped ? '#10B981' : '#3B82F6',
              border: '2px solid white',
              borderRadius: '50%',
              pointerEvents: 'none',
              zIndex: 1002,
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
              transition: 'all 0.2s',
              transform: isSnapped ? 'scale(1.3)' : 'scale(1)',
            }}
          />
        );
      })}
    </>
  );
};

export default memo(ConnectionPoints);

